var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvWerderBremenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 133.478,
    height: 200.217,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 35.316 52.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_44070144",
    d: "M17.658 0 0 26.487l17.658 26.487 17.658-26.487z",
    style: {
      fill: "#1d9053"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_44070088",
    d: "M17.658 1.174.783 26.487 17.658 51.8l16.875-25.313L17.658 1.174zM2.133 26.487 17.658 3.2l15.525 23.288-15.525 23.288L2.133 26.487z",
    className: "fil1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_44070864",
    d: "M21.304 42.406s5.292-10.275 5.292-18.212c0-7.938-4.19-13.317-8.6-13.317-3.307 0-4.453 2.513-4.453 3.968 0 1.456 1.41 2.69 2.69 2.69 1.543 0 2.107-1.021 2.107-1.021 1.95 1.153 5.39 2.917 5.213 9.973-.124 4.937-.794 5.777-1.72 8.687-1.411-3.704-4.233-9.922-4.233-9.922l-4.454 9.746s-1.836-4.19-1.94-10.099c-.013-.705-.013-1.016.265-3.574 1.984 0 3.13-.791 3.13-2.6 0-1.745-1.543-2.645-2.646-2.645-1.102 0-3.88 1.102-3.88 6.35 0 9.128 5.865 19.844 5.865 19.844l3.66-7.276 3.704 7.408z",
    className: "fil1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvWerderBremenLogo);
export default __webpack_public_path__ + "static/media/SV-Werder-Bremen-Logo.229db4e1b8e7517709270529677136d1.svg";
export { ForwardRef as ReactComponent };